// eslint-disable-next-line @typescript-eslint/naming-convention
/* eslint-disable @typescript-eslint/naming-convention */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const envirometAPP     ='EASYBILL::DESARROLLO';
const codEnvirometAPP  ='PROD';
const debug            = true;
const URL_BASE         = 'https://api.easybill.cl';
const appTokenImg      = '006493466351a5c4317df911ea830ad43d7eed64b41586832035'; // Token para imagenes de la aplicacion
const appImgURL        = 'https://api.easybill.cl/img/snapshot/es/'
const appTokenFile     = 'CCA067D69814CADAE0536B01A8C00150'; // Token para Archivos
const appTokenQueue    = 'CCA067D69814CADAE0536B01A8C00150'; // Token para Archivos
const appTokenSSO      = 'CCA067D69814CADAE0536B01A8C00150'; // Token para Archivos
const appTokenUser     = localStorage.getItem('appToken');
const appImgSizeA      = '/thumbnail';
const appImgSizeB      = '/large';
const appImgSizeC      = '/icon';
const qzTrayDigitalKey = "-----BEGIN CERTIFICATE-----\nMIIFAzCCAu2gAwIBAgIENjQwMTALBgkqhkiG9w0BAQUwgZgxCzAJBgNVBAYTAlVT\nMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0cmllcywgTExDMRswGQYD\nVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMMEHF6aW5kdXN0cmllcy5j\nb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1c3RyaWVzLmNvbTAeFw0x\nOTA1MTIwNDAwMDBaFw0yMDA1MTMwNDAwMDBaMIHOMQswCQYDVQQGDAJWTjEWMBQG\nA1UECAwNTk9UIEFWQUlMQUJMRTERMA8GA1UEBwwITmFtIERpbmgxEDAOBgNVBAoM\nB1JvY2tQT1MxEDAOBgNVBAsMB1JvY2tQT1MxEDAOBgNVBAMMB1JvY2tQT1MxIDAe\nBgkqhkiG9w0BCQEMEW1zbjY3ODlAZ21haWwuY29tMTwwOgYDVQQNDDNyZW5ld2Fs\nLW9mLWUyODhjNGUzMGYyZjg5ZTFmMzY4MjFiMjdkM2NiMmI0NTJhOTkwMjcwggEg\nMAsGCSqGSIb3DQEBAQOCAQ8AMIIBCgKCAQEAuGx7/B8lOxg6c2aDZAdwlM/J5lk/\nJGP14lWX3XTSQbMzo1CBSECFQZMHHT7JLQq7IHgrRMSUBXfDcJt3usx5Y6oEAWHp\nKG3CiKTe5XICmpqUAbPLquCAylF/YZfkMAiTXv85pTpdStZKV2kKziOpGwuEvYqi\naI7Suu9lMgO06YN9sf6yuLkx9YPdVCxVs6TVMclO8e+zmzg8LbfpwfAK9h0BUJdB\nd+0o2II0OI/zrm6EWejQozXT4CjWgkgi2F0VjXCl5BTNQqdwuONX3qlMDRlXUQRP\nGZtLCP+tQy0z0fhuF5bn8zQRcgmFyt+T9fGnpncPqejnR97jEEy/DS0EmQIDAQAB\noyMwITAfBgNVHSMEGDAWgBSQplC3hNS56l/yBYQTeEXoqXVUXDALBgkqhkiG9w0B\nAQUDggIBACa1EU9k8saNzJ62+dy0mAREAcDHs8iOpHykNkZjnnWNX/+pKvxAEFyM\nuB+/HK2vSOlkpQwTFFoLHPlfRKvACqbWgL2w873eKERipAIT+GFMbHiT6aKcQgPZ\nzmMEUBFIwoolnNKxrUJ4RBJaD+SMPMTIv8YmTWK5tjkjUWfd16eZY0IJiWuCksuT\nXzo9pXtZphQhTMzEk2ag8C83VgcmJy8zG2Xc8PixfFnQ5cmz2lZSDza+UA4mcllz\nSPXGxl0YzSreIMLqE42qrnY1QazAXLR44sy1qxQoDqdBG0T043WAqdjpOhZXqPap\nR/upogWR5tm83nTT53QX5BtlEH+7GfLsriRlQ0u+h8DWq+plgB+SjzND7Z8bQWz5\ntc9Wrd6x9Mvt12duEPTU+rpvB16YzhW/3YTQAq2UfoI1vW/PSYQt2/XkRVo1WTNN\ngsEXTXAFBRfBswKGMRzr9AAClJOmYP0Bue4AXzf3PCNJTmNza32VdJPbDsOtbOF7\npsy7mAUvx/a7a4IotinJd3NiFw9hd8M3mLp7X19982NSYEASg+PguheTE+XeA0X8\nkZID7hfnhhatto5T02zvAXgTveaOeUG1B/hoEC1PgOwok+JwEgb2HRCJmcQXIrPP\nprw9MykTWQUVwJWD8EQRZG5hnsgWrGUvnxgJET5jPgCJuubMe7fs\n-----END CERTIFICATE-----\n--START INTERMEDIATE CERT--\n-----BEGIN CERTIFICATE-----\nMIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT\nMQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ\nbmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG\nA1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx\nemluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow\ngZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0\ncmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM\nEHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1\nc3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU\niohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H\nYpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM\nGAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH\nEtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh\n0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX\nxOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1\n9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE\nZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD\n2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX\n6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY\n5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ\nplC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S\nBkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ\neUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k\ngDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT\nx8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu\npz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw\n2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp\nrbO7BnjW\n-----END CERTIFICATE-----"
const pathPublic       = 'https://pos.easybill.cl/assets' 
const sendBug          = false
const keyCrypt         = "hola mundo"
const arrDTEFast : any = [33,34,52,56,61,39,41]
const months: any[] = [
    {value: 1, viewValue: 'Enero'},
    {value: 2, viewValue: 'Febrero'},
    {value: 3, viewValue: 'Marzo'},
    {value: 4, viewValue: 'Abril'}, 
    {value: 5, viewValue: 'Mayo'},
    {value: 6, viewValue: 'Junio'},
    {value: 7, viewValue: 'Julio'},
    {value: 8, viewValue: 'Agosto'},
    {value: 9, viewValue: 'Septiembre'},
    {value: 10, viewValue: 'Octubre'},
    {value: 11, viewValue: 'Noviembre'},
    {value: 12, viewValue: 'Diciembre'}
  ];
    const daysOrderReturn: any[] = [
                                      {value: -1 , gls: 'Siempre'},
                                      {value: 0  , gls: 'No permite devolución'},
                                      {value: 30 , gls: '1 Mes'},
                                      {value: 91 , gls: '3 Meses'},
                                      {value: 182, gls: '6 Meses'},
                                      {value: 365, gls: '1 año'},
                                    ];

const postPayURL    = [
                        {name:"transbank",url:"https://localhost:8090/", path: "/socket.io"}
                      ]  
export const environment = {
    envirometAPP     : envirometAPP,
    codEnvirometAPP  : codEnvirometAPP,
    production       : false,
    debug            : debug,
    appTokenImg      : appTokenImg,
    appTokenFile     : appTokenFile,
    appTokenSSO      : appTokenSSO,
    appTokenQueue    : appTokenQueue,
    appTokenUser     : appTokenUser,
    appImgURL        : appImgURL,
    appImgSizeA      : appImgSizeA,
    appImgSizeB      : appImgSizeB,
    appImgSizeC      : appImgSizeC,
    qzTrayDigitalKey : qzTrayDigitalKey,
    pathPublic       : pathPublic,
    sendBug          : sendBug,
    keyCrypt         : keyCrypt,
    months           : months,
    arrDTEFast       :arrDTEFast,
    postPayURL       : postPayURL,
    daysOrderReturn  : daysOrderReturn,
    endPoints: {
        'signInSSO':             URL_BASE +'/'+ 'sso/signIn',
        'ssoData':              URL_BASE + '/'+ 'sso/info/login/',
        'ssoDataUdp':           URL_BASE + '/'+ 'sso/info',
        'ssoPasswdUdp':         URL_BASE + '/'+ 'sso/udpPassword',
        'ssoAvatar':            URL_BASE + '/'+ 'sso/avatar',
        'forgotpasswdEmailApp': URL_BASE + '/'+ 'sso/forgotpasswd/app',

        //'uploadImg':             URL_BASE +'/'+ 'desa-img/snapshot',
        'location':              URL_BASE +'/'+ 'dte/location/v1',
        'addressType':           URL_BASE +'/'+ 'erp/crm/customer/address/type/v1',

        'pdf':                   URL_BASE +'/'+ 'dte/pdf/',
        'xml':                   URL_BASE +'/'+ 'dte/xml/',
        'pdfExt':                URL_BASE +'/'+ 'dte/pdfExt/',
        'xmlExt':                URL_BASE +'/'+ 'dte/xmlExt/',
        'pdfTkt':                URL_BASE +'/'+ 'dte/tkt/pdf/',
        'pdfCtz':                URL_BASE +'/'+ 'dte/ctz/pdf/',
        'format':                URL_BASE +'/'+ 'dte/format/v1',
        'logoEmisor':            URL_BASE +'/'+ 'dte/emisor/logo/v1/', // param: rut
        'emisorData':            URL_BASE +'/'+ 'dte/emisor/usr/v1/', // param: rut
        'emisorInfo':            URL_BASE +'/'+ 'dte/emisor/v1/', // param: rut
        'emisorContactosInfo':   URL_BASE +'/'+ 'dte/emisor/contactos/v1/', // param: rut
        'emisorCertificados':    URL_BASE +'/'+ 'dte/emisor/certificado/v1/', // param: rut
        'emisorSucursales':      URL_BASE +'/'+ 'dte/emisor/sucursal/v1/', // param: rut
        'emisorUsers':           URL_BASE +'/'+ 'dte/emisor/usuarios/v1/', // param: rut
        'receptor':              URL_BASE +'/'+ 'dte/emisor/receptor/v1/', // param: rut
        'emitDTE':               URL_BASE +'/'+ 'dte/dte/v1',
        'infoDTE':               URL_BASE +'/'+ 'dte/dte/make/data/v1',
        'chkDTE':                URL_BASE +'/'+ 'dte/chk/v1',
        'summary':               URL_BASE +'/'+ 'dte/summary/v1/'+ '_$ENV$_' +'/', // params: rutEmpresa, mes, ano
        'summaryBOL':            URL_BASE +'/'+ 'dte/summary/BOL/v1/'+ '_$ENV$_' +'/', // params: rutEmpresa, mes, ano
        'summaryDTE':            URL_BASE +'/'+ 'dte/summary/DTE/v1/'+ '_$ENV$_' +'/', // params: rutEmpresa, mes, ano
        'summaryTKT':            URL_BASE +'/'+ 'dte/summary/TKT/v1/'+ '_$ENV$_' +'/', // params: rutEmpresa, mes, ano
        'summaryRecibos':        URL_BASE +'/'+ 'dte/list/compras/v1/' + '_$ENV$_' + '/', // params: rutEmpresa, mes, ano
        'listDTE':               URL_BASE +'/'+ 'dte/list/dte/v1/'+ '_$ENV$_' +'/', // params: rutEmpresa, mes, ano
        'listBOL':               URL_BASE +'/'+ 'dte/list/bol/v1/'+ '_$ENV$_' +'/', // params: rutEmpresa, mes, ano
        'listTKT':               URL_BASE +'/'+ 'dte/list/tkt/v1/'+ '_$ENV$_' +'/', // params: rutEmpresa, mes, ano
        'listCTZ':               URL_BASE +'/'+ 'dte/list/ctz/v1/'+ '_$ENV$_' +'/', // params: rutEmpresa, mes, ano
        'JSON':                  URL_BASE +'/'+ 'dte/json/', // params: uuid
        'genNotaCredito':        URL_BASE +'/'+ 'dte/json/nc/v1/', // params: uuid ,typeNC
        'genNotaDebito':         URL_BASE +'/'+ 'dte/json/nd/v1/', // params: uuid ,typeND
        'caf':                   URL_BASE +'/'+ 'dte/emisor/caf/v1/', //params: Enviroment , rutEmisor
        'ctz':                   URL_BASE +'/'+ 'dte/ctz/v1',
        'tkt':                   URL_BASE +'/'+ 'dte/tkt/v1',
        'makeDTEFromCTZ':        URL_BASE +'/'+ 'dte/ctz/dte/', // params: uuid, tipoDoc
        'dteLight':              URL_BASE +'/'+ 'dte/dte/light/v1',//:appToken/:idEpcSalesChannel
        'pdfB64':                URL_BASE +'/'+ 'dte/pdf-B64',///:uuid/:paper/:cedible
        'pdfTktB64':             URL_BASE +'/'+ 'dte/tkt/pdf-B64',///:uuid/:paper/:cedible
        'jsonTed':               URL_BASE +'/'+ 'dte/json/ted',///:uuid
        'jsonTKT':               URL_BASE +'/'+ 'dte/jsonTKT',///:uuid/:paper/:cedible
  

        'getFilteredCatalog':    URL_BASE +'/'+ 'erp/psServices/v1/', // params: tokenApp, year, month, day, codFamily?
        'getAllCatalog':         URL_BASE +'/'+ 'erp/psServicesAll/v1/', // params: tokenApp, year, month, day, codFamily?
        'getCatalogByCharCode':  URL_BASE +'/'+ 'erp/psServices/invoice/v1/', //params: tokenApp, codSalesChanel, groupTypeChargeCode, year, month, day, codFamily?
        'groups':                URL_BASE +'/'+ 'erp/psGroup/v1/', // params: userID
        'categorias':            URL_BASE +'/'+ 'erp/psCategory/v1/', // params: userID
        'types':                 URL_BASE +'/'+ 'erp/psType/v1/', // params: userID
        'costs':                 URL_BASE +'/'+ 'erp/psServices/cost/v1/', // params: userID
        'currency':              URL_BASE +'/'+ 'erp/currency/v1/', // params: userID
        'getCostItems':          URL_BASE +'/'+ 'erp/psServices/costItem/v1/', // params: appToken, codProd
        'taxes':                 URL_BASE +'/'+ 'erp/tax/v1/', // params: appToken, codProd
        'price':                 URL_BASE +'/'+ 'erp/psServices/price/v1',
        'salesChannel':          URL_BASE +'/'+ 'erp/epcSalesChannel/v1/', // params: userID
        'providers':             URL_BASE +'/'+ 'erp/supplier/v1/', // params: userID
        'chargeCode':            URL_BASE +'/'+ 'erp/cc/v1/',
        'billingCodes':          URL_BASE +'/'+ 'erp/ccBilling/v1/', // params: appToken
        'groupsChargeCode':      URL_BASE +'/'+ 'erp/ccGroup/v1/', // params: appToken
        'chargeCodeType':        URL_BASE +'/'+ 'erp/ccType/v1/', // params: token

        
        
        'warehouse':             URL_BASE +'/'+ 'erp/warehouse/v1/', // params: appToken
        'warehouseType':         URL_BASE +'/'+ 'erp/warehouse/type/v1/', // params: appToken
        'reasonCodes':           URL_BASE +'/'+ 'erp/cm/reasonCode/v1/', // params: appToken
        'statusCodes':           URL_BASE +'/'+ 'erp/warehouse/cndcn/v1//', // params: appToken
        'documentTypes':         URL_BASE +'/'+ 'erp/cm/docType/v1/', // params: appToken
        'guiaDeEntrada':         URL_BASE +'/'+ 'erp/warehouse/movements/v1/', // params: appToken
        'getAllMovimientosWH':   URL_BASE +'/'+ 'erp/warehouse/movements/v1/', // params: appToken, year, month
        'warehouseMovementsDetail':   URL_BASE +'/'+ 'erp/warehouse/movements/detail/v1', // params: appToken, year, month
        'clientes':              URL_BASE +'/'+ 'erp/crm/customer/LIST/v1/',
        'cliente':               URL_BASE +'/'+ 'erp/crm/customer/v1/', // params: rut

        'clientesPagination':         URL_BASE +'/'+ 'erp/crm/customer/list/pag/v1',// /:appToken/:rankCustomer/:page/:perPage/:from/:searchTerm/:orderBy        

        'inteactions':           URL_BASE +'/'+ 'erp/crm/customer/interaction/v1/',
        'interactionsDetail':    URL_BASE +'/'+ 'erp/crm/customer/interaction/detail/v1/', // params: appToken, uuidCustomer, uuidInteraction
        'inteactionsTree':       URL_BASE +'/'+ 'erp/cm/interactionTree/v1/', // params: appToken
       'interactionAnswer':          URL_BASE + '/'+ 'erp/cm/interaction/answer/v1',                 // :appToken/:idCmInteractionT2     
        //
        'interactionList':       URL_BASE +'/'+ 'erp/crm/customer/interaction/list/v1/', // params: appToken
        'interactionListPagination':  URL_BASE +'/'+ 'erp/crm/customer/interaction/list/pag/v1', // params:/:appToken/:uuidCustomer/:codInteractionStatus/:uuidInteractionT1/:uuidInteractionT2/:year/:month/:page/:perPage/:from/:searchTerm/:orderBy
        //
        'customerNote':          URL_BASE +'/'+ 'erp/crm/customer/note/v1/', // params: appToken
        'customerAddress':       URL_BASE +'/'+ 'erp/crm/customer/address/v1/', // params: appToken
        'customerData':          URL_BASE +'/'+ 'erp/crm/customer/rs/v1', ////:appToken/:rut
        'rpt':                   URL_BASE +'/'+ 'erp/rpt/v1/', // params: appToken
        'rptExe':                URL_BASE +'/'+ 'erp/rpt/exe/v1', // params: appToken
        'rptDownload':           URL_BASE +'/'+ 'erp/rpt/download/v1'
        //
        ,'version':                   URL_BASE +'/'+ 'erp/cm/version/v1'
        ,'modulosAll':           URL_BASE +'/'+ 'erp/cm/module/v1'
        ,'modulosCustomer':      URL_BASE +'/'+ 'erp/cm/owner/module/v1'
        ,'employee':             URL_BASE +'/'+ 'erp/cm/employee/v1/'

        ,'userMenu':             URL_BASE +'/'+ 'erp/cm/menu/v1'
        ,'userNotifications':    URL_BASE +'/'+ 'erp/cm/notifications/v1/'
        ,'userData':             URL_BASE +'/'+ ''
        ,'userAvatar':           URL_BASE +'/'+ ''
        ,'getAppOwnerModule':    URL_BASE + '/'+ 'erp/cm/owner/module/v1/', // params: rut Empresa

        'storageLevel':          URL_BASE + '/'+ 'erp/psServices/storageLevel/v1/', // params: appToken

        ///////////////////////////////////////////
        //SALES POINT
        'sp':                       URL_BASE + '/'+ 'erp/sp/v1',
        'spDetail':                 URL_BASE + '/'+ 'erp/sp/detail/v1',
        'spEployeeList':            URL_BASE + '/'+ 'erp/sp/employee/list/v1',
        'spEployee':                URL_BASE + '/'+ 'erp/sp/employee/v1',
        'spPsServices':             URL_BASE + '/'+ 'erp/sp/psServices/v1',
        'spPsServicesLigth':        URL_BASE + '/'+ 'erp/sp/psServices/ligth/v1', //:appToken/:uuidSp/:uuidWh/:date
        

        'spPsServicesPagination':   URL_BASE + '/'+ 'erp/sp/psServices/pagination/v1',
        'spPsServiceSingle':        URL_BASE + '/'+ 'erp/sp/psService/single/v1', //:appToken/:uuidSP/:uuidWH/:date/:uuidPsServices



        'spPsServicesStorageTotal': URL_BASE + '/'+ 'erp/sp/psServices/storage/total/v1',
        'spOpen':                   URL_BASE + '/'+ 'erp/sp/open/v1',
        'spClose':                  URL_BASE + '/'+ 'erp/sp/close/v1',
        'spCert':                   URL_BASE + '/'+ 'erp/sp/cert/v1', 
        'preClose':                 URL_BASE + '/'+ 'erp/sp/preclose/v1',  ///sp/preclose/v1/:appToken/:uuidSp 
        'spPrinter':                URL_BASE + '/'+ 'erp/sp/printer/v1',
        //
        'chkSpServicesBundle':     URL_BASE + '/'+ 'erp/sp/chk/bundle/v1',
        ///////////////////////////////////////////
        //COUPON DISCOUNT
        'discountCouponChk':        URL_BASE + '/'+ 'erp/discountCoupon/chk/v1',
        'discountCouponAT':         URL_BASE + '/'+ 'erp/discountCoupon/at/v1',  
        'discountCouponDetail':     URL_BASE + '/'+ 'erp/discountCoupon/detail/v1', ///:appToken/:codEpcDiscountCoupon      
        ///////////////////////////////////////////
        'dteDetail':                 URL_BASE + '/'+ 'erp/oms/dte/detail/v1',
        
        //ORDER
        'orderPlace':               URL_BASE + '/'+ 'erp/oms/order/place/v1',         
        'orderDte':                 URL_BASE + '/'+ 'erp/oms/order/dte/v1',
        'orderPayment':             URL_BASE + '/'+ 'erp/oms/order/payment/v1',

        'orderDeletePayment':       URL_BASE + '/'+ 'erp/oms/order/payment/delete/v1',


        'orderPaymentLink':         URL_BASE + '/'+ 'erp/oms/order/payment/link/v1',

        'orderNotifySend':          URL_BASE + '/'+ 'erp/oms/order/notify/v1',
        'orderChangeCustomer':      URL_BASE + '/'+ 'erp/oms/order/change/customer/v1',

        'orderClose':               URL_BASE + '/'+ 'erp/oms/order/close/v1',
        //
        'orderList':                URL_BASE + '/'+ 'erp/oms/order/v1', ///:appToken/:uuidSp/:uuidCustomer
        'orderListPagination':      URL_BASE + '/'+ 'erp/oms/order/pag/v1', ///:appToken/:uuidSp/:uuidCustomer/:year/:month/:page/:perPage/:from/:codEomOrderStatus/:uuidCmEmployee/:searchTerm/:orderBy'
        //
        'orderDetail':              URL_BASE + '/'+ 'erp/oms/order/detail/v1',//:appToken/:uuidEomOrder
        'orderStatus':              URL_BASE + '/'+ 'erp/oms/order/status/v1',//:appToken/:idEpcSalesChannel

        'orderReturnPlace':         URL_BASE + '/'+ 'erp/oms/order/return/place/v1',       
        'orderReturnClose':         URL_BASE + '/'+ 'erp/oms/order/return/close/v1',    
        
        'orderDteSave':             URL_BASE + '/'+ 'erp/oms/order/dte/save/v1',

        'orderMessage':             URL_BASE + '/'+ 'erp/oms/order/dte/message/v1', // post y del /oms/order/dte/message/v1/:appToken/:uuidEomOrder/:uuidEomOrderMessage
        'orderCancel':              URL_BASE + '/'+ 'erp/oms/order/cancel/v1',
        'orderRefund':             URL_BASE + '/'+ 'erp/oms/order/refund/v1',

        'orderDelete':              URL_BASE + '/'+ 'erp/oms/order/delete/v1',

        'orderForwardCarrier':      URL_BASE + '/'+ 'erp/oms/order/forward/carrier/v1',
        'orderSetTrackID':          URL_BASE + '/'+ 'erp/oms/order/set/trackid/v1',

        'makeOmsOrderDTE':          URL_BASE + '/'+ 'erp/oms/order/make/dte/v1',
        //        
        //
        'warehouseStorageSummary':  URL_BASE + '/'+ 'erp/warehouse/storage/summary/v1', ///warehouse/storage/summary/v1/:appToken
        'PsWarehouseStorageSummary':URL_BASE + '/'+ 'erp/oms/ps/warehouse/storage/v1', ///ps/warehouse/storage/v1/:appToken
        //        

        'customerValue':              URL_BASE +'/'+ 'erp/crm/customer/value/v1', // params: appToken
        'customerContact':            URL_BASE +'/'+ 'erp/crm/customer/contact/v1', // params: appToken
        'contactType':                URL_BASE +'/'+ 'erp/crm/customer/contactType/v1', ///:appToken'
        'customerRelated':            URL_BASE +'/'+ 'erp/crm/customer/related/v1/', ///:uuidCustomer/:rutCustomer'

        
        'newOmsOrderOT':            URL_BASE + '/'+ 'erp/oms/order/place/ot/v1',
        'getOmsOrderOTLabel':       URL_BASE + '/'+ 'erp/oms/order/label/ot/v1',

        'statusHistory':            URL_BASE + '/'+ 'erp/oms/order/status/history/v1',
        'orderOTTracking':            URL_BASE + '/'+ 'erp/oms/order/tracking/ot/v1',

        'orderCustomize':            URL_BASE + '/'+ 'erp/oms/order/customize/v1',
        'orderCustomizeTmp':         URL_BASE + '/'+ 'erp/oms/order/customize/tmp/v1',        
        //
        'psServicesPriceFlagUpdate':             URL_BASE +'/'+ 'erp/psServices/price/flag/update/v1', // 
        //================================================  
        'dshOperational':            URL_BASE + '/'+ 'erp/dashboard/operational/v1',      //:appToken
        'dshFinancial':              URL_BASE + '/'+ 'erp/dashboard/financial/v1',        //:appToken    
        'dshOperationalLigth':       URL_BASE + '/'+ 'erp/dashboard/operational/ligth/v1',      //:appToken  
        ///////////////////////////////////////////
        'getAllCatalogPagination':    URL_BASE +'/'+ 'erp/psServices/pag/v1',// /appToken/codCategory/codGroup/remove/page/perPage/from/searchTerm/orderBy',  

        'getPsBarcode':               URL_BASE +'/'+ 'erp/psServices/barcode/v1', // params: tokenApp, year, month, day, codFamily?
        'psbrands':                   URL_BASE +'/'+ 'erp/psbrands/v1/', // params: /psbrands/v1/:appToken/:all        
        //
        'storageLevelDay':            URL_BASE +'/'+ 'erp/psServices/storageLevel/day/v1', // params: appToken
        'psReview':                  URL_BASE +'/erp'+ '/ec/ps/review/rating',

        //================================================= 
        'getEpcEsl':            URL_BASE + '/'+ 'erp/epc/esl/v1', //////epc/esl/v1/:appToken
        'getEpcEslDetail':      URL_BASE + '/'+ 'erp/epc/esl/detail/v1', //////epc/esl/detail/v1/:appToken/:uuidPsServicesEslTag
        'epcSetTag':            URL_BASE + '/'+ 'erp/epc/esl/v1', //////epc/esl/v1
        'epcDelTag':            URL_BASE + '/'+ 'erp/epc/esl/v1', //////epc/esl/v1
        'getEpcEslData':        URL_BASE + '/'+ 'erp/epc/esl/data/v1', //////epc/esl/detail/v1/:appToken/:uuidPsServicesEslTag
        'getEpcEslpsServices':  URL_BASE + '/'+ 'erp/epc/esl/psServices/v1', //////epc/esl/detail/v1/:appToken/:uuidPsServicesEslTag
        //================================================    
        'addImgToProduct':            URL_BASE +'/'+ 'erp/psServices/img/v1/', // params: appToken, codProd, img
        'uploadImg':                  URL_BASE +'/'+ 'img/snapshot',
        ///////////////////////////////////////////  
        //
        'psCombination':              URL_BASE +'/'+ 'erp/psServices/combination/v1', // post get :appToken
        'psCombinationProperty':      URL_BASE +'/'+ 'erp/psServices/combination/property/v1', 
        'psCombinationPropertyValue': URL_BASE +'/'+ 'erp/psServices/combination/property/value/v1', 
        'psCombinationDetail':        URL_BASE +'/'+ 'erp/psServices/combination/detail/v1', 
        'psCombinationPs':            URL_BASE +'/'+ 'erp/psServices/combination/ps/v1', 
        'psServicesExternal':         URL_BASE +'/'+ 'erp/psServices/external/v1', 
        //          
        //
        'psServicesDiscount':         URL_BASE +'/'+ 'erp/psServices/discount/v1', 
        'psDiscountFullfillment':     URL_BASE +'/'+ 'erp/psServices/discount/fullfillment/v1',         
        //
        'psBundle':                  URL_BASE +'/'+ 'erp/psServices/bundle/v1',         
        'psBundleDetail':            URL_BASE +'/'+ 'erp/psServices/bundle/detail/v1',         
        //          
        'unitMeasurement':            URL_BASE +'/'+ 'erp/unitMeasurement/v1/', // params: userID 
        //================================================
        'getPsServicesTypeBarcode':         URL_BASE + '/'+ 'erp/ps/barcode/type/v1', //////:appToken 
        //================================================      
        'ctzPlace':                  URL_BASE + '/'+ 'erp/ctz/place/v1',   
        'ctzList':                   URL_BASE + '/'+ 'erp/ctz/v1/',             ///:appToken/:uuidCustomer/:year/:month    
        'ctzDetail':                 URL_BASE + '/'+ 'erp/ctz/detail/v1',      //:appToken/:uuidEomCtz
        'ctzPlaceOrder':             URL_BASE + '/'+ 'erp/ctz/place/order/v1',      //
        'ctzListPagination':         URL_BASE + '/'+ 'erp/ctz/pag/v1/',             ///:appToken/:uuidCustomer/:year/:month/:page/:perPage/:from/:searchTerm/:orderBy   
        'ctz2dte':                    URL_BASE +'/'+ 'dte/ctz/dte', // params: uuid, tipoDoc
        //================================================  
        'getAllMovimientosWHPagination': URL_BASE +'/'+ 'erp/warehouse/movements/pag/v1', // params: :appToken/:type/:uuidCustomer/:year/:month/:page/:perPage/:from/:searchTerm/:orderBy
        //==
        'wareHouseMovementsTransfer':  URL_BASE + '/'+ 'erp/warehouse/transfer/v1', /////warehouse/transfer/v1
        'warehouseMovementsDelete':   URL_BASE +'/'+ 'erp/warehouse/delete/v1', // params: /:appToken/:uuidWarehouseMovement

        
    }
};
/*

                    ,V_PERCENT_TIP           TA_SP.PERCENT_TIPP%TYPE;        
                    ,V_FLAG_DONATION         TA_SP.FLAG_DONATION%TYPE;      
                    ,V_FLAG_ROUND_DONATION   TA_SP.FLAG_ROUND_DONATION%TYPE;        
                    ,V_AMOUNT_DONATION       TA_SP.AMOUNT_DONATION%TYPE;     
                    
                    ',"FLAG_TIP":"'            || V_FLAG_TIP            || '"' ||      
                    ',"PERCENT_TIP":"'         || V_PERCENT_TIP         || '"' ||              
                    ',"FLAG_DONATION":"'       || V_FLAG_DONATION       || '"' ||                
                    ',"FLAG_ROUND_DONATION":"' || V_FLAG_ROUND_DONATION || '"' ||              
                    ',"AMOUNT_DONATION":"'     || V_AMOUNT_DONATION     || '"' ||          

                     ',"LAST_NAME2":"'         || V_LAST_NAME2           || '"' ||  


export const environment = {
    production: false,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    URL_BASE: 'https://api.easybill.cl/',
    appToken: '006493466351a5c4317df911ea830ad43d7eed64b41586832035',
    endPoints: {
        'pdf':            'dte/pdf/',
        'pdfTkt':         'desa/tkt/pdf/',
        'pdfCtz':         'desa/ctz/pdf/',
        'format':         'dte/format/v1',
        'receptor':       'desa/emisor/receptor/v1/', // param: rut
        'emitDTE':        'desa/dte/v1',
        'chkDTE':         'desa/dte/chk/v1',
        'summary':        'desa/summary/v1/CERT/', // params: rutEmpresa, mes, ano
        'summaryBOL':     'desa/summary/BOL/v1/CERT/', // params: rutEmpresa, mes, ano
        'summaryDTE':     'desa/summary/DTE/v1/CERT/', // params: rutEmpresa, mes, ano
        'summaryTKT':     'desa/summary/TKT/v1/CERT/', // params: rutEmpresa, mes, ano
        'listDTE':        'desa/list/dte/v1/CERT/', // params: rutEmpresa, mes, ano
        'listBOL':        'desa/list/bol/v1/CERT/', // params: rutEmpresa, mes, ano
        'listTKT':        'desa/list/tkt/v1/CERT/', // params: rutEmpresa, mes, ano
        'listCTZ':        'desa/list/ctz/v1/CERT/', // params: rutEmpresa, mes, ano
        'JSON':           'desa/json/', // params: uuid
        'genNotaCredito': 'desa/json/nc/v1/', // params: uuid ,typeNC
        'genNotaDebito':  'desa/json/nd/v1/', // params: uuid ,typeND
        'getCatalog':     'desa-epc/psServices/', // params: tokenApp, year, month, day, codFamily?
        'familys':        'desa-epc/psGroup/', // params: userID
        'currency':       'desa-epc/currency/', // params: userID
        'ctz':            'desa/ctz/v1',
        'makeDTEFromCTZ': 'desa/ctz/dte/', // params: uuid, tipoDoc
        'location':       'desa/location/v1',

    }
};


*/
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.